@if (toolRegistrations && toolRegistrations.length) {
<tr><td colspan="3"><b>Mezzi</b></td></tr>
  @for (item of toolRegistrations; track item) {
    @if( item.phaseCode == currentPhaseCode){
    <tr>
      <td></td>
      <td>{{item.toolDescription}}</td>
      <td align="right">{{item.oreLavorate}}</td>
    </tr>
    }
  }
}
